module.exports = __webpack_public_path__ + "static/img/inquiry-bulletin-banner.f2c5b4cc.png";